import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './module.styl'

export default class Module extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    withFooter: PropTypes.bool,
    xs: PropTypes.bool
  }

  render() {
    const { children, withFooter, xs } = this.props
    const moduleClasses = [styles.module]

    withFooter && moduleClasses.push(styles.withFooter)
    xs && moduleClasses.push(styles.xs)

    return (
      <div className={moduleClasses.join(' ')}>
        {children}
      </div>
    )
  }
}
